import React from "react";

import { IProduct } from "../../../models/catalogue";
import { PriceType, getProductPrice } from "../../../utils/catalogue";
import { LinePrice } from "./LinePrice";

export const WishlistLinePrice = (props: {
    product: IProduct;
}): React.ReactNode => {
    const product = props.product;
    return (
        <LinePrice
            retailPrice={getProductPrice(product.price, {
                priceType: PriceType.RETAIL,
                includePostDiscountAddons: false,
                quantity: 1,
            })}
            linePriceInclDiscounts={getProductPrice(product.price, {
                priceType: PriceType.COSMETIC_EXCL_TAX,
                includePostDiscountAddons: true,
                quantity: 1,
            })}
            postDiscountAddons={product.price.post_discount_addons}
            quantity={1}
        />
    );
};
